import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_CAMPAIGNS_BUDGETS](state, payload) {
    state.campaignsBudgets = payload;
  },
  [MutationsType.ADD_CAMPAIGN_BUDGET](state, payload) {
    state.campaignsBudgets.push(payload);
  },
  [MutationsType.UPDATE_CAMPAIGN_BUDGET](state, payload) {
    let ind = state.campaignsBudgets.findIndex((campaignBudget) => campaignBudget.id === payload.id);
    if (ind >= 0) Vue.set(state.campaignsBudgets, ind, { ...state.campaignsBudgets[ind], ...payload });
  },
  [MutationsType.REMOVE_CAMPAIGN_BUDGET](state, payload) {
    let ind = state.campaignsBudgets.findIndex((t) => t.id === payload);
    Vue.delete(state.campaignsBudgets, ind);
  },
  [MutationsType.SET_CAMPAIGN_BUDGET_DOWNLOADS](state, payload) {
    state.campaignsBudgetsDownloads = payload;
  },
  [MutationsType.ADD_CAMPAIGN_BUDGET_DOWNLOAD](state, payload) {
    if (!state.campaignsBudgetsDownloads.some((item) => item.id === payload.id)) {
      state.campaignsBudgetsDownloads.unshift(payload);
    }
  },
  [MutationsType.UPDATE_CAMPAIGN_BUDGET_DOWNLOAD](state, payload) {
    let ind = (state.campaignsBudgetsDownloads || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0)
      Vue.set(state.campaignsBudgetsDownloads, ind, { ...state.campaignsBudgetsDownloads[ind], ...payload.data });
  },
  [MutationsType.REMOVE_CAMPAIGN_BUDGET_DOWNLOAD](state, payload) {
    let ind = state.campaignsBudgetsDownloads.findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.campaignsBudgetsDownloads, ind);
  },
};
